import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './cardTitle.module.scss';

export default memo(function CardTitle(props) {
    const [t] = useTranslation(props.dictionary);

    return (
        <div className={styles.titleContainer}>
            <span>{t(props.title)}</span>
            <span>{t(props.description)}</span>
        </div>
    );
}, (prevProps, nextProps) =>
        prevProps.dictionary === nextProps.dictionary &&
        prevProps.title === nextProps.title &&
        prevProps.description === nextProps.description
);
